import React from 'react';
import AUTimelineComponent from './components/AUTimelineComponent';
import './styles/app.scss';

const App = () => [
  <AUTimelineComponent
    key={0}
    container="au_timeline"
  />,
];

export default App;
